<template>
<div>
  <FormRow inline>
      <FormCol field="street" :readonly="readonly"/>
      <FormCol field="street2" :readonly="readonly"/>
  </FormRow>
  <FormRow inline>
      <FormCol field="city" :flex="2" :readonly="readonly"/>
      <FormCol field="state" :flex="1"><StateSelector :country="form.country" :readonly="readonly"/></FormCol>
      <FormCol field="zip" :flex="1" :readonly="readonly"/>
  </FormRow>
  <FormRow inline>
      <FormCol field="country" width="half"><CountrySelector :lang="lang" :readonly="readonly"/></FormCol>
  </FormRow>
</div>
</template>
<script setup lang="ts">
import { usePaymentForm } from '~/shared/use-payment-form'

defineProps<{
  lang?: string
  readonly?: boolean
}>()

const { form } = usePaymentForm()
</script>